'use client';

export { default } from './CircularProgress';
export { default as circularProgressClasses } from './circularProgressClasses';
export * from './circularProgressClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CircularProgress/index.js
// module id = 832
// module chunks = 22